module.exports = __webpack_public_path__ + "static/c2c-logo-343f5598119bb7e6d2c4d8a3bd754f59.jpg";